// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"4939e08f","741":"977d6f39"}[chunkId] + ".chunk.js";
};